import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const BookingSuccess = () => {
  const navigate = useNavigate();

  // Go back to home page
  const goToHome = () => {
    navigate("/");
  };

  return (
    <>
      <Navbar />
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            {/* Success Card */}
            <div className="card shadow text-center">
              <div className="card-body py-5">
                <div className="success-icon mb-4">
                  <div className="rounded-circle bg-success d-inline-flex justify-content-center align-items-center" style={{ width: "80px", height: "80px" }}>
                    <i className="fas fa-check text-white fa-3x"></i>
                  </div>
                </div>
                <h2 className="fw-bold mb-3">Thank you!</h2>
                <p className="text-muted mb-4">Your guest house is successfully booked</p>
                
                <button 
                  onClick={goToHome} 
                  className="btn btn-primary px-4 py-2"
                >
                  Go Back Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BookingSuccess;